/**
 * @generated SignedSource<<98cfb203dbdd1cdd9735bc883979d655>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletionReason = "AUTO" | "MANUAL";
export type DeleteNoteModalDeleteVideoMutation$variables = {
  recordingId: string;
};
export type DeleteNoteModalDeleteVideoMutation$data = {
  readonly deleteMeetingRecordingVideo: {
    readonly meetingRecording: {
      readonly id: string;
      readonly meetingRecordedVideoDuration: number | null;
      readonly meetingRecordedVideoPosterUrl: string | null;
      readonly meetingRecordedVideoUrl: string | null;
      readonly meetingRecordingVideoDeletionReason: DeletionReason | null;
      readonly transcript: any | null;
      readonly transcriptDeletionReason: DeletionReason | null;
    };
  } | null;
};
export type DeleteNoteModalDeleteVideoMutation = {
  response: DeleteNoteModalDeleteVideoMutation$data;
  variables: DeleteNoteModalDeleteVideoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recordingId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "recordingId"
      }
    ],
    "concreteType": "DeleteMeetingRecordingVideo",
    "kind": "LinkedField",
    "name": "deleteMeetingRecordingVideo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecording",
        "kind": "LinkedField",
        "name": "meetingRecording",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transcript",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transcriptDeletionReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordedVideoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordedVideoPosterUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordedVideoDuration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "meetingRecordingVideoDeletionReason",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNoteModalDeleteVideoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNoteModalDeleteVideoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "45c0fe2174f2617c8cde17b6f5f4b11a",
    "id": null,
    "metadata": {},
    "name": "DeleteNoteModalDeleteVideoMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNoteModalDeleteVideoMutation(\n  $recordingId: ID!\n) {\n  deleteMeetingRecordingVideo(meetingRecordingId: $recordingId) {\n    meetingRecording {\n      id\n      transcript\n      transcriptDeletionReason\n      meetingRecordedVideoUrl\n      meetingRecordedVideoPosterUrl\n      meetingRecordedVideoDuration\n      meetingRecordingVideoDeletionReason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4db6a75a866c2329b229bf09fa832700";

export default node;
